module.exports = __webpack_public_path__ + "static/media/cancel.96a3910a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Parts/svg/cancel.svg
// module id = 1081
// module chunks = 1